import { GET_SHOPKEEPER_INFORMATION_LIST } from "../../../Types";

const ShopKeeperInformationListReducer = (state = [], action) => {
  switch (action.type) {
    case GET_SHOPKEEPER_INFORMATION_LIST:
  return {
    ...state,
    data: action.payload?.data || [],          // Make sure this exists
    totalRecords: action.payload?.totalRecords || 0, // And this exists
  };
    default:
      return state
  }
}
export default ShopKeeperInformationListReducer;
